// 기능이 사용되는 페이지에 "본 제품은 한글과컴퓨터의 HWP 문서 파일(.hwp,.hwpx) 공개 문서를 참고하여 개발하였습니다." 노출
import {
  PAPER_TABS,
  PAPER_CONFIG,
  AUDIO_PAPER_TYPE,
} from '../../../data/common.js';
import { strParse } from '../../../lib/util.js';
import JSZip from 'jszip';
import {
  container_rdf,
  content_hpf,
  headerScripts_js,
  manifest_xml,
  settings_xml,
  sourceScripts_js,
  header_xml,
  container_xml,
  version_xml,
  mimetype,
  base_background,
} from './cvBaseData.js';

const MAX_SINGLE_WIDTH = 54000;
const MAX_DOUBLE_WIDTH = 25500;
const NUMBER_WIDTH = 2500;
const OPTION_NUMBER_WIDTH = 1133;

async function createHwpx(newSectionXml, base64Img) {
  const zip = new JSZip();

  zip.file('Contents/content.hpf', content_hpf, {
    compression: 'DEFLATE',
    compressionOptions: { level: 9 },
    unixPermissions: '644',
  });
  zip.file('Contents/header.xml', header_xml, {
    compression: 'DEFLATE',
    compressionOptions: { level: 9 },
    unixPermissions: '644',
  });

  // 기존 파일을 업데이트 (section0.xml 덮어쓰기)
  zip.file('Contents/section0.xml', newSectionXml, {
    compression: 'DEFLATE',
    compressionOptions: { level: 9 },
    unixPermissions: '644',
  });

  zip.file('META-INF/container.rdf', container_rdf, {
    compression: 'DEFLATE',
    compressionOptions: { level: 9 },
    unixPermissions: '644',
  });
  zip.file('META-INF/container.xml', container_xml, {
    compression: 'DEFLATE',
    compressionOptions: { level: 9 },
    unixPermissions: '644',
  });
  zip.file('META-INF/manifest.xml', manifest_xml, {
    compression: 'DEFLATE',
    compressionOptions: { level: 9 },
    unixPermissions: '644',
  });
  zip.folder('Preview');
  zip.file('Scripts/headerScripts.js', headerScripts_js, {
    compression: 'DEFLATE',
    compressionOptions: { level: 9 },
    unixPermissions: '644',
  });
  zip.file('Scripts/sourceScripts.js', sourceScripts_js, {
    compression: 'DEFLATE',
    compressionOptions: { level: 9 },
    unixPermissions: '644',
  });
  zip.file('mimetype', mimetype, {
    compression: 'DEFLATE',
    compressionOptions: { level: 9 },
    unixPermissions: '644',
  });
  zip.file('settings.xml', settings_xml, {
    compression: 'DEFLATE',
    compressionOptions: { level: 9 },
    unixPermissions: '644',
  });

  zip.file('version.xml', version_xml, {
    compression: 'DEFLATE',
    compressionOptions: { level: 9 },
    unixPermissions: '644',
  });

  function base64ToArrayBuffer(base64) {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer; // 🔹 ArrayBuffer 반환
  }

  const backgroundBuffer = base64ToArrayBuffer(base_background);
  zip.file('BinData/image1.jpg', backgroundBuffer, {
    compression: 'DEFLATE',
    compressionOptions: { level: 9 },
    unixPermissions: '644',
  });

  // Base64 이미지를 압축에 추가
  if (base64Img) {
    //const base64Data = base64Img.replace(/^data:image\/\w+;base64,/, '');
    const imageBuffer = base64Img; //base64ToArrayBuffer(base64Data);
    zip.file('BinData/image2.png', imageBuffer, {
      compression: 'DEFLATE',
      compressionOptions: { level: 9 },
      unixPermissions: '644',
    });
  }

  // ZIP을 Buffer로 변환 (Node.js 환경)
  const hwpxBuffer = await zip.generateAsync({
    type: 'blob',
    compression: 'DEFLATE',
    compressionOptions: { level: 9 },
  });

  return hwpxBuffer;
}

// 헤더 역할을 하는 표 생성
const createHeaderTable = (
  orgName,
  className,
  teacherName,
  paperName,
  base64Img,
  fontSize,
) => {
  let img = `<hp:run charPrIDRef="6" />`;
  if (base64Img != null) {
    img = `<hp:run charPrIDRef="6">
                  <hp:rect id="1766242655" zOrder="153" numberingType="PICTURE"
                      textWrap="TOP_AND_BOTTOM" textFlow="BOTH_SIDES" lock="0"
                      dropcapstyle="None" href="" groupLevel="0"
                      instid="692500832" ratio="0">
                      <hp:offset x="0" y="0" />
                      <hp:orgSz width="8504" height="8504" />
                      <hp:curSz width="5254" height="3923" />
                      <hp:flip horizontal="0" vertical="0" />
                      <hp:rotationInfo angle="0" centerX="2627" centerY="1961"
                          rotateimage="1" />
                      <hp:renderingInfo>
                          <hc:transMatrix e1="1" e2="0" e3="0" e4="0" e5="1"
                              e6="0" />
                          <hc:scaMatrix e1="0.617827" e2="0" e3="0" e4="0"
                              e5="0.461312" e6="0" />
                          <hc:rotMatrix e1="1" e2="0" e3="0" e4="0" e5="1" e6="0" />
                      </hp:renderingInfo>
                      <hp:lineShape color="#000000" width="33" style="NONE"
                          endCap="FLAT" headStyle="NORMAL" tailStyle="NORMAL"
                          headfill="1" tailfill="1" headSz="SMALL_SMALL"
                          tailSz="SMALL_SMALL" outlineStyle="NORMAL" alpha="0" />
                      <hc:fillBrush>
                          <hc:winBrush faceColor="#FFFFFF" hatchColor="#000000"
                              alpha="0" />
                          <hc:imgBrush mode="ZOOM">
                              <hc:img binaryItemIDRef="image2" bright="0"
                                  contrast="0" effect="REAL_PIC" alpha="0" />
                          </hc:imgBrush>
                      </hc:fillBrush>
                      <hp:shadow type="NONE" color="#B2B2B2" offsetX="0"
                          offsetY="0" alpha="0" />
                      <hc:pt0 x="0" y="0" />
                      <hc:pt1 x="8504" y="0" />
                      <hc:pt2 x="8504" y="8504" />
                      <hc:pt3 x="0" y="8504" />
                      <hp:sz width="5254" widthRelTo="ABSOLUTE" height="3923"
                          heightRelTo="ABSOLUTE" protect="0" />
                      <hp:pos treatAsChar="1" affectLSpacing="0" flowWithText="0"
                          allowOverlap="1" holdAnchorAndSO="0" vertRelTo="PAPER"
                          horzRelTo="PAPER" vertAlign="TOP" horzAlign="LEFT"
                          vertOffset="2834" horzOffset="2834" />
                      <hp:outMargin left="0" right="0" top="0" bottom="0" />
                      <hp:shapeComment>사각형입니다.</hp:shapeComment>
                  </hp:rect>
                  <hp:t />
              </hp:run>`;
  }
  return `<hp:tbl id="${Date.now()}" zOrder="5" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                  textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="CELL" repeatHeader="1"
                  rowCnt="2" colCnt="4" cellSpacing="0" borderFillIDRef="3" noAdjust="0">
                  <hp:sz width="${MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                  <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                      holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="COLUMN" vertAlign="TOP"
                      horzAlign="LEFT" vertOffset="110" horzOffset="0" />
                  <hp:outMargin left="0" right="0" top="0" bottom="0" />
                  <hp:inMargin left="424" right="424" top="113" bottom="113" />
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="CENTER" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  ${img}
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${base64Img == null ? 0 : 5602}" height="3298" />
                          <hp:cellMargin left="0" right="0" top="0" bottom="0" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="CENTER" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              ${
                                base64Img == null
                                  ? `<hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="2">
                                          <hp:t>${orgName}</hp:t>
                                      </hp:run>
                                  </hp:p>`
                                  : ''
                              }
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="2">
                                      <hp:t>${className}</hp:t>
                                  </hp:run>
                              </hp:p>
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="2">
                                      <hp:t>${teacherName}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="10000" height="3298" />
                          <hp:cellMargin left="0" right="0" top="0" bottom="0" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="CENTER" lineWrap="BREAK"
                              vertAlign="CENTER" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="13" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="4">
                                      <hp:t>${paperName}</hp:t>
                                  </hp:run>
                                  <hp:run charPrIDRef="${fontSize[0]}" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="2" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${base64Img == null ? 33000 : 23000}" height="3298" />
                          <hp:cellMargin left="0" right="0" top="0" bottom="0" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="7">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="CENTER" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="19" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="21">
                                      <hp:t>(이름)</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="3" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${base64Img == null ? 5000 : 15602}" height="3298" />
                          <hp:cellMargin left="0" right="0" top="0" bottom="0" />
                      </hp:tc>
                  </hp:tr>
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="6">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="CENTER" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="13" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="17" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="1" />
                          <hp:cellSpan colSpan="4" rowSpan="1" />
                          <hp:cellSz width="53647" height="500" />
                          <hp:cellMargin left="0" right="0" top="0" bottom="0" />
                      </hp:tc>
                  </hp:tr>
              </hp:tbl>
              <hp:ctrl>
                  <hp:footer id="15" applyPageType="BOTH">
                      <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK" vertAlign="BOTTOM"
                          linkListIDRef="0" linkListNextIDRef="0" textWidth="53860" textHeight="1417"
                          hasTextRef="0" hasNumRef="0">
                          <hp:p id="0" paraPrIDRef="0" styleIDRef="0" pageBreak="0" columnBreak="0"
                              merged="0">
                              <hp:run charPrIDRef="0">
                                  <hp:ctrl>
                                      <hp:autoNum num="1" numType="PAGE">
                                          <hp:autoNumFormat type="DIGIT" userChar="" prefixChar=""
                                              suffixChar="" supscript="0" />
                                      </hp:autoNum>
                                  </hp:ctrl>
                                  <hp:t />
                              </hp:run>
                          </hp:p>
                      </hp:subList>
                  </hp:footer>
              </hp:ctrl>`;
};

// 문제 제목 생성
const createSubject = (subjectText, fontSize) => {
  return `<hp:p id="0" paraPrIDRef="15" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
          <hp:run charPrIDRef="${fontSize[1]}">
              <hp:t>※ ${subjectText}</hp:t>
          </hp:run>
      </hp:p>
      <hp:p id="0" paraPrIDRef="15" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
          <hp:run charPrIDRef="3" />
      </hp:p>`;
};

// 마지막 간격
const createLine = () => {
  return `<hp:p id="0" paraPrIDRef="15" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
            <hp:run charPrIDRef="5" />
        </hp:p>`;
};

// A타입 텍스트 항목 생성
const createAtypeItem = (
  index,
  text,
  paperTab,
  fontSize,
  lineSpacing,
  columCount,
) => {
  // '시험지', '정답표시 시험지'
  let result;
  if (
    paperTab === PAPER_TABS.TEST_PAPER ||
    paperTab === PAPER_TABS.ANSWER_TEST_PAPER
  ) {
    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
          <hp:run charPrIDRef="${fontSize[0]}">
              <hp:tbl id="${Date.now()}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                  textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                  repeatHeader="0" rowCnt="2" colCnt="3" cellSpacing="0" borderFillIDRef="3"
                  noAdjust="1">
                  <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                  <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                      holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                      horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                  <hp:outMargin left="0" right="0" top="0" bottom="0" />
                  <hp:inMargin left="0" right="0" top="141" bottom="283" />
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${index}.</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${text.question}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${((columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH) / 2}" height="0" />
                          <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                          borderFillIDRef="6">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="BOTTOM" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="0" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${paperTab === PAPER_TABS.TEST_PAPER ? '' : text.answer}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="2" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${((columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH) / 2}" height="0" />
                          <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="3" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="1" />
                          <hp:cellSpan colSpan="3" rowSpan="1" />
                          <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="${lineSpacing}" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
              </hp:tbl>
              <hp:t />
          </hp:run>
      </hp:p>`;
  }
  // '정답만' 시험지
  else if (paperTab === PAPER_TABS.ANSWER) {
    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="0" rowCnt="1" colCnt="2" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="1">
                      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                      <hp:outMargin left="0" right="0" top="0" bottom="0" />
                      <hp:inMargin left="0" right="0" top="141" bottom="283" />
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${index}.</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${text.answer}</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                  </hp:tbl>
                  <hp:t />
              </hp:run>
          </hp:p>`;
  }
  return result;
};

// B타입 텍스트 항목 생성
const createBtypeItem = (
  index,
  text,
  paperTab,
  fontSize,
  lineSpacing,
  vocaFirstWordShow,
  columCount,
) => {
  // '시험지', '정답표시 시험지'
  let result;
  if (
    paperTab === PAPER_TABS.TEST_PAPER ||
    paperTab === PAPER_TABS.ANSWER_TEST_PAPER
  ) {
    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="0" rowCnt="2" colCnt="3" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="1">
                      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                      <hp:outMargin left="0" right="0" top="0" bottom="0" />
                      <hp:inMargin left="0" right="0" top="141" bottom="283" />
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${index}.</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${text.question}</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${((columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH) / 2}" height="0" />
                              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                              borderFillIDRef="6">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="BOTTOM" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="${vocaFirstWordShow ? 24 : 23}" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${
                                            vocaFirstWordShow
                                              ? paperTab ===
                                                PAPER_TABS.TEST_PAPER
                                                ? text.answer[0]
                                                : text.answer
                                              : paperTab ===
                                                  PAPER_TABS.TEST_PAPER
                                                ? ''
                                                : text.answer
                                          }</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="2" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${((columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH) / 2}" height="0" />
                              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="3" />
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="1" />
                              <hp:cellSpan colSpan="3" rowSpan="1" />
                              <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="${lineSpacing}" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                  </hp:tbl>
                  <hp:t />
              </hp:run>
          </hp:p>`;
  }
  // '정답만' 시험지
  else if (paperTab === PAPER_TABS.ANSWER) {
    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="0" rowCnt="1" colCnt="2" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="1">
                      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                      <hp:outMargin left="0" right="0" top="0" bottom="0" />
                      <hp:inMargin left="0" right="0" top="141" bottom="283" />
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${index}.</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="1324" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${paperTab === PAPER_TABS.TEST_PAPER ? '' : text.answer}</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                  </hp:tbl>
                  <hp:t />
              </hp:run>
          </hp:p>`;
  }
  return result;
};

// C타입 텍스트 항목 생성
const createCtypeItem = (
  index,
  text,
  paperTab,
  fontSize,
  lineSpacing,
  vocaFirstWordShow,
  columCount,
) => {
  // '시험지', '정답표시 시험지'
  let result;
  if (
    paperTab === PAPER_TABS.TEST_PAPER ||
    paperTab === PAPER_TABS.ANSWER_TEST_PAPER
  ) {
    let content = [
      ...text.questions.map(subText => {
        return paperTab === PAPER_TABS.TEST_PAPER
          ? [
              ...(subText.questionSentence ?? '')
                .split(/(\{[^{}]*\}|[^\s{}]+)/) // {} 내부와 외부를 구분하면서 split
                .filter(Boolean) // 빈 문자열 제거
                .flatMap(word => {
                  if (word.startsWith('{') && word.endsWith('}')) {
                    // {}로 둘러싸인 경우 처리
                    const editWord = word
                      .replace(/[{}]/g, '') // {} 제거
                      .split('^');
                    const words = editWord.map((_, idx) => {
                      return idx === editWord?.length - 1
                        ? `<hp:run charPrIDRef="${fontSize[0]}">
                              <hp:t>${vocaFirstWordShow ? `${editWord[idx][0]}__________________` : '___________________'}</hp:t>
                          </hp:run>`
                        : `<hp:run charPrIDRef="${fontSize[0]}">
                              <hp:t>${vocaFirstWordShow ? `${editWord[idx][0]}__________________ ` : '___________________ '}</hp:t>
                          </hp:run>`;
                    });
                    return words.join('');
                  } else {
                    // 일반 단어 처리
                    return `<hp:run charPrIDRef="${fontSize[0]}">
                              <hp:t>${word + ''}</hp:t>
                          </hp:run>`;
                  }
                }),
            ].join('')
          : [
              ...(subText.questionSentence ?? '')
                .split(/(\{[^{}]*\}|[^\s{}]+)/) // {} 내부와 외부를 구분하면서 split
                .filter(Boolean) // 빈 문자열 제거
                .map(word => {
                  if (word.startsWith('{') && word.endsWith('}')) {
                    // {} 내부 텍스트 처리
                    const cleanedText = word
                      .replace(/[{}]/g, '') // {} 제거
                      .replace(/[!@#$%&*()?><":;.,]/g, '') // 특수문자 제거
                      .split('^');
                    // ^로 분리 후 각 단어를 밑줄 처리
                    return cleanedText
                      .flatMap((cleanWord, idx) =>
                        [
                          `<hp:run charPrIDRef="${fontSize[2]}">
                              <hp:t>${cleanWord}`,
                          idx === cleanedText?.length - 1 ? `` : ` `,
                          `</hp:t>
                          </hp:run>`,
                        ].join(''),
                      )
                      .join('');
                  } else {
                    // 일반 단어 처리
                    return `<hp:run charPrIDRef="${fontSize[0]}">
                              <hp:t>${word + ''}</hp:t>
                          </hp:run>`;
                  }
                }),
            ].join('');
      }),
    ].join('');

    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}" zOrder="2" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="1" rowCnt="3" colCnt="2" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="0">
                      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                      <hp:outMargin left="141" right="141" top="141" bottom="141" />
                      <hp:inMargin left="0" right="0" top="141" bottom="283" />
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${index}.</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="10" styleIDRef="2" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${[
                                            ...text.questions.map(subText => {
                                              return subText.questionTranslation;
                                            }),
                                          ].join('')}</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}" />
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="1" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="10" styleIDRef="2" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      ${content}
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="1" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="3" />
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="2" />
                              <hp:cellSpan colSpan="2" rowSpan="1" />
                              <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="${lineSpacing}" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                  </hp:tbl>
                  <hp:t />
              </hp:run>
          </hp:p>`;
  }
  // '정답만' 시험지
  else if (paperTab === PAPER_TABS.ANSWER) {
    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}${index}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="0" rowCnt="1" colCnt="2" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="1">
                      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                      <hp:outMargin left="0" right="0" top="0" bottom="0" />
                      <hp:inMargin left="0" right="0" top="141" bottom="283" />
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${index}.</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="1324" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${text.word}</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                  </hp:tbl>
                  <hp:t />
              </hp:run>
          </hp:p>`;
  }
  return result;
};

// D타입 텍스트 항목 생성
const createDtypeItem = (
  index,
  text,
  paperTab,
  fontSize,
  lineSpacing,
  vocaFirstWordShow,
  columCount,
) => {
  // '시험지', '정답표시 시험지'
  let result;
  if (
    paperTab === PAPER_TABS.TEST_PAPER ||
    paperTab === PAPER_TABS.ANSWER_TEST_PAPER
  ) {
    let content = [
      ...text.synonyms.map((word, t_index) => {
        return `<hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="6" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t> -</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="${t_index * 3 + 2}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="20" styleIDRef="2" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>(${word.type}) </hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="${t_index * 3 + 2}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="6">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="BOTTOM" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="${vocaFirstWordShow ? 24 : 23}" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${
                                            vocaFirstWordShow
                                              ? paperTab ===
                                                PAPER_TABS.TEST_PAPER
                                                ? word.answer[0]
                                                : word.answer
                                              : paperTab ===
                                                  PAPER_TABS.TEST_PAPER
                                                ? ''
                                                : word.answer // 정답 필드
                                          }</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="2" rowAddr="${t_index * 3 + 2}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${((columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH * 2) / 2}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="10" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${word.meaning}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                              <hp:cellAddr colAddr="3" rowAddr="${t_index * 3 + 2}" />
                          <hp:cellSpan colSpan="1" rowSpan="2" />
                          <hp:cellSz width="${((columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH * 2) / 2}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="3" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="${t_index * 3 + 3}" />
                          <hp:cellSpan colSpan="3" rowSpan="1" />
                          <hp:cellSz width="0" height="0" />
                          <hp:cellMargin left="0" right="0" top="0" bottom="0" />
                      </hp:tc>
                  </hp:tr>
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="3" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="${t_index * 3 + 4}" />
                          <hp:cellSpan colSpan="4" rowSpan="1" />
                          <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="${lineSpacing}" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>`;
      }),
    ].join('');

    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}${index}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                  textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                  repeatHeader="1" rowCnt="${2 + text.synonyms.length * 3}" colCnt="4" cellSpacing="0" borderFillIDRef="3"
                  noAdjust="0">
                  <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                  <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                      holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                      horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                  <hp:outMargin left="141" right="141" top="141" bottom="141" />
                  <hp:inMargin left="0" right="0" top="141" bottom="141" />
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="1" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${index}.</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${strParse(text.question)}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="0" />
                          <hp:cellSpan colSpan="3" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="3" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="1" />
                          <hp:cellSpan colSpan="4" rowSpan="1" />
                          <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="${lineSpacing}" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  ${content}
              </hp:tbl>
              <hp:t />
          </hp:run>
      </hp:p>`;
  }
  // '정답만' 시험지
  else if (paperTab === PAPER_TABS.ANSWER) {
    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}${index}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="0" rowCnt="1" colCnt="2" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="1">
                      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                      <hp:outMargin left="0" right="0" top="0" bottom="0" />
                      <hp:inMargin left="0" right="0" top="141" bottom="283" />
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${index}.</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${[
                                            ...text.synonyms.map(
                                              (word, indx) => {
                                                const length =
                                                  text?.synonyms?.length;
                                                return indx !== length - 1
                                                  ? `${word.answer}, `
                                                  : word.answer;
                                              },
                                            ),
                                          ].join('')}</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                  </hp:tbl>
                  <hp:t />
              </hp:run>
          </hp:p>`;
  }
  return result;
};

// E타입 텍스트 항목 생성
const createEtypeItem = (
  index,
  text,
  paperTab,
  fontSize,
  lineSpacing,
  vocaFirstWordShow,
  columCount,
) => {
  // '시험지', '정답표시 시험지'
  let result;
  if (
    paperTab === PAPER_TABS.TEST_PAPER ||
    paperTab === PAPER_TABS.ANSWER_TEST_PAPER
  ) {
    let content = [
      ...text.deriveds.map((word, t_index) => {
        return `<hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="6" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t> -</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="${t_index * 3 + 2}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="12" styleIDRef="2" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="${t_index * 3 + 2}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH / 2}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="6">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="BOTTOM" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="${vocaFirstWordShow ? 24 : 23}" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${
                                        vocaFirstWordShow
                                          ? paperTab === PAPER_TABS.TEST_PAPER
                                            ? word.answer[0]
                                            : word.answer
                                          : paperTab === PAPER_TABS.TEST_PAPER
                                            ? ''
                                            : word.answer
                                      }</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="2" rowAddr="${t_index * 3 + 2}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${((columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH - NUMBER_WIDTH / 2) / 2}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="1" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${word.question}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="3" rowAddr="${t_index * 3 + 2}" />
                          <hp:cellSpan colSpan="1" rowSpan="2" />
                          <hp:cellSz width="${((columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH - NUMBER_WIDTH / 2) / 2}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="3" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="${t_index * 3 + 3}" />
                          <hp:cellSpan colSpan="3" rowSpan="1" />
                          <hp:cellSz width="0" height="0" />
                          <hp:cellMargin left="0" right="0" top="0" bottom="0" />
                      </hp:tc>
                  </hp:tr>
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="3" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="${t_index * 3 + 4}" />
                          <hp:cellSpan colSpan="4" rowSpan="1" />
                          <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="${lineSpacing}" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>`;
      }),
    ];

    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
          <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}${index}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                  textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="0" rowCnt="${2 + text.deriveds.length * 3}" colCnt="4" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="1">
                      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                  <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                      holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                      horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                  <hp:outMargin left="141" right="141" top="141" bottom="141" />
                  <hp:inMargin left="0" right="0" top="141" bottom="141" />
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="1" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${index}.</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="1" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${strParse(text.question)}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="0" />
                          <hp:cellSpan colSpan="3" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="3" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="1" />
                          <hp:cellSpan colSpan="4" rowSpan="1" />
                          <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="${lineSpacing}" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  ${content}
              </hp:tbl>
              <hp:t />
          </hp:run>
      </hp:p>`;
  }
  // '정답만' 시험지
  else if (paperTab === PAPER_TABS.ANSWER) {
    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}${index}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="0" rowCnt="1" colCnt="2" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="1">
                     <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                      <hp:outMargin left="0" right="0" top="0" bottom="0" />
                      <hp:inMargin left="0" right="0" top="141" bottom="283" />
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${index}.</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${[
                                            ...text.deriveds.map(
                                              (word, indx) => {
                                                const length =
                                                  text?.deriveds?.length;
                                                return indx !== length - 1
                                                  ? `${word.answer}, `
                                                  : word.answer;
                                              },
                                            ),
                                          ].join('')}</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                  </hp:tbl>
                  <hp:t />
              </hp:run>
          </hp:p>`;
  }
  return result;
};

// F타입 텍스트 항목 생성
const createFtypeItem = (
  index,
  text,
  paperTab,
  fontSize,
  lineSpacing,
  vocaFirstWordShow,
  columCount,
) => {
  // '시험지', '정답표시 시험지'
  let result;
  if (
    paperTab === PAPER_TABS.TEST_PAPER ||
    paperTab === PAPER_TABS.ANSWER_TEST_PAPER
  ) {
    result = `<hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
          <hp:run charPrIDRef="${fontSize[0]}">
              <hp:tbl id="${Date.now()}${index}" zOrder="6" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                  textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                  repeatHeader="0" rowCnt="2" colCnt="4" cellSpacing="0" borderFillIDRef="3"
                  noAdjust="1">
                  <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                  <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                      holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                      horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                  <hp:outMargin left="0" right="0" top="0" bottom="0" />
                  <hp:inMargin left="0" right="0" top="141" bottom="283" />
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${index}.</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                          borderFillIDRef="6">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="BOTTOM" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="${vocaFirstWordShow ? 24 : 23}" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${
                                        text.audioQuestionType ===
                                        AUDIO_PAPER_TYPE.KOR
                                          ? paperTab === PAPER_TABS.TEST_PAPER
                                            ? ''
                                            : strParse(text.meanings)
                                          : vocaFirstWordShow
                                            ? paperTab === PAPER_TABS.TEST_PAPER
                                              ? text.answer[0]
                                              : text.answer
                                            : paperTab === PAPER_TABS.TEST_PAPER
                                              ? ''
                                              : text.answer
                                      }</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${((columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH * 2) / 2}" height="0" />
                          <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="19" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="2" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                          borderFillIDRef="${text.audioQuestionType === AUDIO_PAPER_TYPE.ENG_KOR ? 6 : 1}">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="19" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${
                                        text.audioQuestionType ===
                                        AUDIO_PAPER_TYPE.ENG_KOR
                                          ? paperTab === PAPER_TABS.TEST_PAPER
                                            ? ''
                                            : strParse(text.meanings)
                                          : ''
                                      }</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="3" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${((columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH * 2) / 2}" height="0" />
                          <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="3" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="1" />
                          <hp:cellSpan colSpan="4" rowSpan="1" />
                          <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="${lineSpacing}" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
              </hp:tbl>
              <hp:t />
          </hp:run>
      </hp:p>`;
  }
  // '정답만' 시험지
  else if (paperTab === PAPER_TABS.ANSWER) {
    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}${index}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="0" rowCnt="1" colCnt="2" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="1">
                      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                      <hp:outMargin left="0" right="0" top="0" bottom="0" />
                      <hp:inMargin left="0" right="0" top="141" bottom="283" />
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${index}.</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${text.answer} ${strParse(text.meanings)}</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                  </hp:tbl>
                  <hp:t />
              </hp:run>
          </hp:p>`;
  }
  return result;
};

// G타입 텍스트 항목 생성
const createGtypeItem = (
  index,
  text,
  paperTab,
  fontSize,
  lineSpacing,
  vocaFirstWordShow,
  columCount,
) => {
  // '시험지', '정답표시 시험지'
  let result;
  if (
    paperTab === PAPER_TABS.TEST_PAPER ||
    paperTab === PAPER_TABS.ANSWER_TEST_PAPER
  ) {
    result = `<hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
          <hp:run charPrIDRef="${fontSize[0]}">
              <hp:tbl id="${Date.now()}${index}" zOrder="7" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                  textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                  repeatHeader="1" rowCnt="4" colCnt="3" cellSpacing="0" borderFillIDRef="5"
                  noAdjust="1">
                  <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                  <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                      holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                      horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                  <hp:outMargin left="141" right="141" top="141" bottom="141" />
                  <hp:inMargin left="0" right="0" top="141" bottom="283" />
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="17" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${index}.</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${strParse(text.question)}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="0" />
                          <hp:cellSpan colSpan="2" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="17" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="3" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="1" />
                          <hp:cellSpan colSpan="3" rowSpan="1" />
                          <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="${lineSpacing}" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="17" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="2" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                          borderFillIDRef="6">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="BOTTOM" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="${vocaFirstWordShow ? 24 : 23}" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${
                                        vocaFirstWordShow
                                          ? paperTab === PAPER_TABS.TEST_PAPER
                                            ? text.answer[0]
                                            : text.answer
                                          : paperTab === PAPER_TABS.TEST_PAPER
                                            ? ''
                                            : text.answer
                                      }</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="2" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${((columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH) / 2}" height="0" />
                          <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="2" rowAddr="2" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${((columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH) / 2}" height="0" />
                          <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="17" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="3" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="3" />
                          <hp:cellSpan colSpan="3" rowSpan="1" />
                          <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="${lineSpacing}" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
              </hp:tbl>
              <hp:t />
          </hp:run>
      </hp:p>`;
  }
  // '정답만' 시험지
  else if (paperTab === PAPER_TABS.ANSWER) {
    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}${index}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="0" rowCnt="1" colCnt="2" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="1">
                      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                      <hp:outMargin left="0" right="0" top="0" bottom="0" />
                      <hp:inMargin left="0" right="0" top="141" bottom="283" />
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${index}.</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${text.answer}</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                  </hp:tbl>
                  <hp:t />
              </hp:run>
          </hp:p>`;
  }
  return result;
};

// H타입 텍스트 항목 생성
const createHtypeItem = (
  index,
  text,
  paperTab,
  fontSize,
  lineSpacing,
  columCount,
) => {
  // '시험지', '정답표시 시험지'
  let result;
  if (
    paperTab === PAPER_TABS.TEST_PAPER ||
    paperTab === PAPER_TABS.ANSWER_TEST_PAPER
  ) {
    result = `<hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
          <hp:run charPrIDRef="${fontSize[0]}">
              <hp:tbl id="${Date.now()}${index}" zOrder="8" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                  textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                  repeatHeader="1" rowCnt="6" colCnt="3" cellSpacing="0" borderFillIDRef="3"
                  noAdjust="0">
                  <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                  <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                      holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                      horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                  <hp:outMargin left="141" right="141" top="141" bottom="141" />
                  <hp:inMargin left="0" right="0" top="141" bottom="283" />
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="CENTER" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${index}.</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="CENTER" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${strParse(text.question)}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="0" />
                          <hp:cellSpan colSpan="2" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  ${[
                    ...text.options.map((option, oIdx) => {
                      return `<hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="${oIdx + 1}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="10" styleIDRef="2" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${String.fromCharCode(9312 + oIdx)}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="${oIdx + 1}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${OPTION_NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="8" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${
                                    paperTab === PAPER_TABS.ANSWER_TEST_PAPER &&
                                    text.answer === oIdx + 1
                                      ? fontSize[2]
                                      : fontSize[0]
                                  }">
                                      <hp:t>${option}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="2" rowAddr="${oIdx + 1}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH * 2}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>`;
                    }),
                  ].join('')}
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="3" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="5" />
                          <hp:cellSpan colSpan="3" rowSpan="1" />
                          <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="${lineSpacing}" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
              </hp:tbl>
              <hp:t />
          </hp:run>
      </hp:p>`;
  }
  // '정답만' 시험지
  else if (paperTab === PAPER_TABS.ANSWER) {
    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}${index}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="0" rowCnt="1" colCnt="2" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="1">
                      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                      <hp:outMargin left="0" right="0" top="0" bottom="0" />
                      <hp:inMargin left="0" right="0" top="141" bottom="283" />
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${index}.</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${String.fromCharCode(9312 + text?.answer - 1)}</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                  </hp:tbl>
                  <hp:t />
              </hp:run>
          </hp:p>`;
  }
  return result;
};

// I타입 텍스트 항목 생성
const createItypeItem = (
  index,
  text,
  paperTab,
  fontSize,
  lineSpacing,
  columCount,
) => {
  // '시험지', '정답표시 시험지'
  let result;
  if (
    paperTab === PAPER_TABS.TEST_PAPER ||
    paperTab === PAPER_TABS.ANSWER_TEST_PAPER
  ) {
    result = `<hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
          <hp:run charPrIDRef="${fontSize[0]}">
              <hp:tbl id="${Date.now()}${index}" zOrder="9" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                  textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                  repeatHeader="1" rowCnt="6" colCnt="3" cellSpacing="0" borderFillIDRef="3"
                  noAdjust="0">
                 <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                  <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                      holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                      horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                  <hp:outMargin left="141" right="141" top="141" bottom="141" />
                  <hp:inMargin left="0" right="0" top="141" bottom="283" />
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${index}.</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="8" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${strParse(text.question)}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="0" />
                          <hp:cellSpan colSpan="2" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  ${[
                    ...text.options.map((option, oIdx) => {
                      return `<hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="${oIdx + 1}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="1182" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="10" styleIDRef="2" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${String.fromCharCode(9312 + oIdx)}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="${oIdx + 1}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${OPTION_NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="8" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${
                                    paperTab === PAPER_TABS.ANSWER_TEST_PAPER &&
                                    text.answer === oIdx + 1
                                      ? fontSize[2]
                                      : fontSize[0]
                                  }">
                                      <hp:t>${option}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="2" rowAddr="${oIdx + 1}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${((columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH * 2) / 2}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>`;
                    }),
                  ].join('')}
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="3" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="5" />
                          <hp:cellSpan colSpan="3" rowSpan="1" />
                          <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="${lineSpacing}" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
              </hp:tbl>
              <hp:t />
          </hp:run>
      </hp:p>`;
  }
  // '정답만' 시험지
  else if (paperTab === PAPER_TABS.ANSWER) {
    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}${index}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="0" rowCnt="1" colCnt="2" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="1">
                      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                      <hp:outMargin left="0" right="0" top="0" bottom="0" />
                      <hp:inMargin left="0" right="0" top="141" bottom="283" />
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${index}.</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${String.fromCharCode(9312 + text?.answer - 1)}</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                  </hp:tbl>
                  <hp:t />
              </hp:run>
          </hp:p>`;
  }
  return result;
};

// J타입 텍스트 항목 생성
const createJtypeItem = (
  index,
  text,
  paperTab,
  fontSize,
  lineSpacing,
  examKorShow,
  columCount,
) => {
  // '시험지', '정답표시 시험지'
  let result;
  let answerTextIndex = null; // 영문 정답단어 식별용
  if (
    paperTab === PAPER_TABS.TEST_PAPER ||
    paperTab === PAPER_TABS.ANSWER_TEST_PAPER
  ) {
    result = `<hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
          <hp:run charPrIDRef="${fontSize[0]}">
              <hp:tbl id="${Date.now()}${index}" zOrder="10" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                  textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                  repeatHeader="1" rowCnt="7" colCnt="3" cellSpacing="0" borderFillIDRef="3"
                  noAdjust="0">
                  <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                  <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                      holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                      horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                  <hp:outMargin left="141" right="141" top="141" bottom="141" />
                  <hp:inMargin left="0" right="0" top="0" bottom="0" />
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${index}.</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="10" styleIDRef="2" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  ${[
                                    ...text.sentence
                                      .split(' ')
                                      .map((text, tIndex) => {
                                        let isAnswerText = false;
                                        if (
                                          text.includes('{') &&
                                          text.includes('}')
                                        ) {
                                          isAnswerText = true;
                                          answerTextIndex = tIndex;
                                        }
                                        let resultText = '';
                                        if (isAnswerText) {
                                          resultText =
                                            answerTextIndex !== null
                                              ? `<hp:run charPrIDRef="${fontSize[2]}">
                                                  <hp:t>${text?.replace(/[{}]/g, '')?.replace(/\^/g, ' ')}</hp:t>
                                                </hp:run>`
                                              : `<hp:run charPrIDRef="${fontSize[2]}">
                                                  <hp:t>${text?.replace(/[{}]/g, '')?.replace(/\^/g, ' ')} </hp:t>
                                                </hp:run>`;
                                        } else {
                                          resultText =
                                            answerTextIndex !== null &&
                                            tIndex === answerTextIndex + 1
                                              ? `<hp:run charPrIDRef="${fontSize[0]}">
                                                  <hp:t> ${text} </hp:t>
                                                </hp:run>`
                                              : `<hp:run charPrIDRef="${fontSize[0]}">
                                                  <hp:t>${text} </hp:t>
                                                </hp:run>`;
                                        }
                                        return resultText;
                                      }),
                                  ].join('')}
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="0" />
                          <hp:cellSpan colSpan="2" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="12" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="1" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="${examKorShow ? 141 : 0}" bottom="${examKorShow ? 141 : 0}" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="10" styleIDRef="2" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  ${
                                    examKorShow
                                      ? `<hp:run charPrIDRef="${fontSize[0]}"><hp:t>(${text?.translation ?? ''})</hp:t></hp:run>`
                                      : `<hp:run charPrIDRef="12"/>`
                                  }
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="1" />
                          <hp:cellSpan colSpan="2" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="${examKorShow ? 141 : 0}" bottom="${examKorShow ? 141 : 0}" />
                      </hp:tc>
                  </hp:tr>
                  ${[
                    ...text.options.map((option, oIdx) => {
                      return `<hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="${oIdx + 2}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="10" styleIDRef="2" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${String.fromCharCode(9312 + oIdx)}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="${oIdx + 2}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${OPTION_NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="8" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${
                                    paperTab === PAPER_TABS.ANSWER_TEST_PAPER &&
                                    text.answer === oIdx + 1
                                      ? fontSize[2]
                                      : fontSize[0]
                                  }">
                                      <hp:t>${option}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="2" rowAddr="${oIdx + 2}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH * 2}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>`;
                    }),
                  ].join('')}
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="3" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="6" />
                          <hp:cellSpan colSpan="3" rowSpan="1" />
                          <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="${lineSpacing}" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
              </hp:tbl>
              <hp:t />
          </hp:run>
      </hp:p>`;
  }
  // '정답만' 시험지
  else if (paperTab === PAPER_TABS.ANSWER) {
    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}${index}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="0" rowCnt="1" colCnt="2" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="1">
                      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                      <hp:outMargin left="0" right="0" top="0" bottom="0" />
                      <hp:inMargin left="0" right="0" top="141" bottom="283" />
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${index}.</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${String.fromCharCode(9312 + text?.answer - 1)}</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                  </hp:tbl>
                  <hp:t />
              </hp:run>
          </hp:p>`;
  }
  return result;
};

// K타입 텍스트 항목 생성
const createKtypeItem = (
  index,
  text,
  paperTab,
  fontSize,
  lineSpacing,
  examKorShow,
  columCount,
) => {
  // '시험지', '정답표시 시험지'
  let result;
  if (
    paperTab === PAPER_TABS.TEST_PAPER ||
    paperTab === PAPER_TABS.ANSWER_TEST_PAPER
  ) {
    result = `<hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
          <hp:run charPrIDRef="${fontSize[0]}">
              <hp:tbl id="${Date.now()}${index}" zOrder="11" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                  textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                  repeatHeader="1" rowCnt="7" colCnt="3" cellSpacing="0" borderFillIDRef="3"
                  noAdjust="0">
                  <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                  <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                      holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                      horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                  <hp:outMargin left="141" right="141" top="141" bottom="141" />
                  <hp:inMargin left="0" right="0" top="0" bottom="0" />
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${index}.</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="10" styleIDRef="2" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  ${[
                                    ...text.sentence.split(' ').map(text => {
                                      let isAnswerText = false;
                                      if (
                                        text.includes('{') &&
                                        text.includes('}')
                                      ) {
                                        isAnswerText = true;
                                      }
                                      let resultText = '';
                                      if (isAnswerText) {
                                        let filter_text = text.substring(
                                          text.indexOf('}') + 1,
                                        );
                                        resultText = `<hp:run charPrIDRef="${fontSize[0]}">
                                                  <hp:t>${'___________________'}${filter_text} </hp:t>
                                                </hp:run>`;
                                      } else {
                                        resultText = `<hp:run charPrIDRef="${fontSize[0]}">
                                                  <hp:t>${text} </hp:t>
                                                </hp:run>`;
                                      }
                                      return resultText;
                                    }),
                                  ].join('')}
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="0" />
                          <hp:cellSpan colSpan="2" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="12" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="1" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="${examKorShow ? 141 : 0}" bottom="${examKorShow ? 141 : 0}" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="10" styleIDRef="2" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  ${
                                    examKorShow
                                      ? `<hp:run charPrIDRef="${fontSize[0]}"><hp:t>(${text?.translation ?? ''})</hp:t></hp:run>`
                                      : `<hp:run charPrIDRef="12"/>`
                                  }
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="1" />
                          <hp:cellSpan colSpan="2" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="${examKorShow ? 141 : 0}" bottom="${examKorShow ? 141 : 0}" />
                      </hp:tc>
                  </hp:tr>
                  ${[
                    ...text.options.map((option, oIdx) => {
                      return `<hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="${oIdx + 2}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="10" styleIDRef="2" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${String.fromCharCode(9312 + oIdx)}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="${oIdx + 2}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${OPTION_NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="8" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${
                                    paperTab === PAPER_TABS.ANSWER_TEST_PAPER &&
                                    text.answer === oIdx + 1
                                      ? fontSize[2]
                                      : fontSize[0]
                                  }">
                                      <hp:t>${option}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="2" rowAddr="${oIdx + 2}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH * 2}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>`;
                    }),
                  ].join('')}
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="3" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="6" />
                          <hp:cellSpan colSpan="3" rowSpan="1" />
                          <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="${lineSpacing}" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  
              </hp:tbl>
              <hp:t />
          </hp:run>
      </hp:p>`;
  }
  // '정답만' 시험지
  else if (paperTab === PAPER_TABS.ANSWER) {
    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}${index}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="0" rowCnt="1" colCnt="2" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="1">
                      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                      <hp:outMargin left="0" right="0" top="0" bottom="0" />
                      <hp:inMargin left="0" right="0" top="141" bottom="283" />
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${index}.</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${String.fromCharCode(9312 + text?.answer - 1)}</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                  </hp:tbl>
                  <hp:t />
              </hp:run>
          </hp:p>`;
  }
  return result;
};

// L타입 텍스트 항목 생성
const createLtypeItem = (
  index,
  text,
  paperTab,
  fontSize,
  lineSpacing,
  columCount,
) => {
  // '시험지', '정답표시 시험지'
  let result;
  if (
    paperTab === PAPER_TABS.TEST_PAPER ||
    paperTab === PAPER_TABS.ANSWER_TEST_PAPER
  ) {
    result = `<hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
          <hp:run charPrIDRef="${fontSize[0]}">
              <hp:tbl id="${Date.now()}${index}" zOrder="12" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                  textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                  repeatHeader="1" rowCnt="6" colCnt="3" cellSpacing="0" borderFillIDRef="3"
                  noAdjust="0">
                  <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                  <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                      holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                      horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                  <hp:outMargin left="141" right="141" top="141" bottom="141" />
                  <hp:inMargin left="0" right="0" top="141" bottom="283" />
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="CENTER" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${index}.</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="CENTER" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="8" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${strParse(text.question)}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="0" />
                          <hp:cellSpan colSpan="2" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  ${[
                    ...text.options.map((option, oIdx) => {
                      return `<hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="${oIdx + 1}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="10" styleIDRef="2" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${String.fromCharCode(9312 + oIdx)}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="${oIdx + 1}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${OPTION_NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="8" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${
                                    paperTab === PAPER_TABS.ANSWER_TEST_PAPER &&
                                    text.answer === oIdx + 1
                                      ? fontSize[2]
                                      : fontSize[0]
                                  }">
                                      <hp:t>${option}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="2" rowAddr="${oIdx + 1}" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH * 2}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>`;
                    }),
                  ].join('')}
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="5" />
                          <hp:cellSpan colSpan="3" rowSpan="1" />
                          <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
              </hp:tbl>
              <hp:t />
          </hp:run>
      </hp:p>`;
  }
  // '정답만' 시험지
  else if (paperTab === PAPER_TABS.ANSWER) {
    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}${index}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="0" rowCnt="1" colCnt="2" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="1">
                      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                      <hp:outMargin left="0" right="0" top="0" bottom="0" />
                      <hp:inMargin left="0" right="0" top="141" bottom="283" />
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${index}.</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${String.fromCharCode(9312 + text?.answer - 1)}</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                  </hp:tbl>
                  <hp:t />
              </hp:run>
          </hp:p>`;
  }
  return result;
};

// M타입 텍스트 항목 생성
const createMtypeItem = (
  index,
  text,
  paperTab,
  fontSize,
  lineSpacing,
  columCount,
) => {
  // '시험지', '정답표시 시험지'
  let result;
  if (
    paperTab === PAPER_TABS.TEST_PAPER ||
    paperTab === PAPER_TABS.ANSWER_TEST_PAPER
  ) {
    result = `<hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
          <hp:run charPrIDRef="${fontSize[0]}">
              <hp:tbl id="${Date.now()}${index}" zOrder="14" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                  textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                  repeatHeader="1" rowCnt="6" colCnt="3" cellSpacing="0" borderFillIDRef="3"
                  noAdjust="0">
                  <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                  <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                      holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                      horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                  <hp:outMargin left="141" right="141" top="141" bottom="141" />
                  <hp:inMargin left="0" right="0" top="141" bottom="283" />
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${index}.</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="0" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${text.question}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="0" />
                          <hp:cellSpan colSpan="2" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>
                  ${[
                    ...text.options.map((option, oIdx) => {
                      return `<hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="1" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="10" styleIDRef="2" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${fontSize[0]}">
                                      <hp:t>${String.fromCharCode(9312 + oIdx)}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="1" rowAddr="1" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${OPTION_NUMBER_WIDTH}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="8" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="${
                                    paperTab === PAPER_TABS.ANSWER_TEST_PAPER &&
                                    text.answer === oIdx + 1
                                      ? fontSize[2]
                                      : fontSize[0]
                                  }">
                                      <hp:t>${option}</hp:t>
                                  </hp:run>
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="2" rowAddr="1" />
                          <hp:cellSpan colSpan="1" rowSpan="1" />
                          <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH * 2}" height="0" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                  </hp:tr>`;
                    }),
                  ].join('')}
                  <hp:tr>
                      <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                          borderFillIDRef="1">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                              vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                              textHeight="0" hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="9" styleIDRef="0" pageBreak="0"
                                  columnBreak="0" merged="0">
                                  <hp:run charPrIDRef="3" />
                              </hp:p>
                          </hp:subList>
                          <hp:cellAddr colAddr="0" rowAddr="5" />
                          <hp:cellSpan colSpan="3" rowSpan="1" />
                          <hp:cellSz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" height="${lineSpacing}" />
                          <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                      </hp:tc>
                      
                  </hp:tr>
              </hp:tbl>
              <hp:t />
          </hp:run>
      </hp:p>`;
  }
  // '정답만' 시험지
  else if (paperTab === PAPER_TABS.ANSWER) {
    result = `<hp:p id="0" paraPrIDRef="3" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="${fontSize[0]}">
                  <hp:tbl id="${Date.now()}${index}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
                      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
                      repeatHeader="0" rowCnt="1" colCnt="2" cellSpacing="0" borderFillIDRef="3"
                      noAdjust="1">
                      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
                      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
                          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
                          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
                      <hp:outMargin left="0" right="0" top="0" bottom="0" />
                      <hp:inMargin left="0" right="0" top="141" bottom="283" />
                      <hp:tr>
                          <hp:tc name="" header="0" hasMargin="1" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${index}.</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="0" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="0" right="0" top="141" bottom="141" />
                          </hp:tc>
                          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
                              borderFillIDRef="1">
                              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                                  textHeight="0" hasTextRef="0" hasNumRef="0">
                                  <hp:p id="0" paraPrIDRef="18" styleIDRef="0" pageBreak="0"
                                      columnBreak="0" merged="0">
                                      <hp:run charPrIDRef="${fontSize[0]}">
                                          <hp:t>${String.fromCharCode(9312 + text?.answer - 1)}</hp:t>
                                      </hp:run>
                                  </hp:p>
                              </hp:subList>
                              <hp:cellAddr colAddr="1" rowAddr="0" />
                              <hp:cellSpan colSpan="1" rowSpan="1" />
                              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) - NUMBER_WIDTH}" height="0" />
                              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
                          </hp:tc>
                      </hp:tr>
                  </hp:tbl>
                  <hp:t />
              </hp:run>
          </hp:p>`;
  }
  return result;
};

// '어휘리스트'의 경우 공통 테이블 양식
const createCommonVocaListItem = (voca, fontSize, columCount, index) => {
  return `<hp:tr>
          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
              borderFillIDRef="8">
              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                  textHeight="0" hasTextRef="0" hasNumRef="0">
                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                      columnBreak="0" merged="0">
                      <hp:run charPrIDRef="${fontSize[0]}">
                          <hp:t>${voca?.eng}</hp:t>
                      </hp:run>
                  </hp:p>
              </hp:subList>
              <hp:cellAddr colAddr="0" rowAddr="${index}" />
              <hp:cellSpan colSpan="1" rowSpan="1" />
              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) / 2}" height="0" />
              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
          </hp:tc>
          <hp:tc name="" header="0" hasMargin="0" protect="0" editable="0" dirty="0"
              borderFillIDRef="8">
              <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK"
                  vertAlign="TOP" linkListIDRef="0" linkListNextIDRef="0" textWidth="0"
                  textHeight="0" hasTextRef="0" hasNumRef="0">
                  <hp:p id="0" paraPrIDRef="11" styleIDRef="0" pageBreak="0"
                      columnBreak="0" merged="0">
                      <hp:run charPrIDRef="${fontSize[0]}">
                          <hp:t>${voca?.kor}</hp:t>
                      </hp:run>
                  </hp:p>
              </hp:subList>
              <hp:cellAddr colAddr="1" rowAddr="${index}" />
              <hp:cellSpan colSpan="1" rowSpan="1" />
              <hp:cellSz width="${(columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH) / 2}" height="0" />
              <hp:cellMargin left="510" right="510" top="141" bottom="141" />
          </hp:tc>
      </hp:tr>`;
};

// 문서 생성 메인 함수
export const createDocumentHWPX = async (
  orgName,
  className,
  teacherName,
  paperName,
  columCount,
  fontSize,
  lineSpacing,
  vocaFirstWordShow,
  examKorShow,
  base64Img,
  generatedPaper,
  paperTab,
  commonPaperVocaList,
) => {
  const normalId = 1; //9pt
  const normalBoldId = 8; //9pt
  const normalBoldUnderlineId = 7; //9pt
  const smallId = 35; //7pt
  const smallBoldId = 36; //7pt
  const smallBoldUnderlineId = 39; //7pt
  const largeId = 37; //11pt
  const largeBoldId = 38; //11pt
  const largeBoldUnderlineId = 40; //11pt

  const fontSizeMap = {
    [PAPER_CONFIG.FONT_SIZE.SMALL]: [
      smallId,
      smallBoldId,
      smallBoldUnderlineId,
    ],
    [PAPER_CONFIG.FONT_SIZE.NORMAL]: [
      normalId,
      normalBoldId,
      normalBoldUnderlineId,
    ],
    [PAPER_CONFIG.FONT_SIZE.LARGE]: [
      largeId,
      largeBoldId,
      largeBoldUnderlineId,
    ],
  };

  // fontSize가 정의되지 않은 경우, 기본값으로 NORMAL을 사용
  let wordTextSize =
    fontSizeMap[fontSize] || fontSizeMap[PAPER_CONFIG.FONT_SIZE.NORMAL];
  // 줄간격
  let lineSpacingValue = 240;
  if (lineSpacing === PAPER_CONFIG.LINE_SPACING.SMALL) {
    lineSpacingValue = 193; // 0.8pt
  } else if (lineSpacing === PAPER_CONFIG.LINE_SPACING.NORMAL) {
    lineSpacingValue = 240; // 1.0pt
  } else if (lineSpacing === PAPER_CONFIG.LINE_SPACING.LARGE) {
    lineSpacingValue = 276; // 1.15pt
  }

  // '시험지/정답만/정답시험지' 13개 유형별로 항목 생성
  const makedItems = () => {
    let items = [];
    generatedPaper.forEach(type => {
      // 유형문제
      if (paperTab !== PAPER_TABS.ANSWER) {
        items.push(createSubject(type.title, wordTextSize));
      }
      // 답변부
      type.questions.forEach((voca, index) => {
        switch (type.type) {
          case 'A':
            items.push(
              createAtypeItem(
                type.startNo + index,
                voca,
                paperTab,
                wordTextSize,
                lineSpacingValue,
                columCount,
              ),
            );
            break;
          case 'B':
            items.push(
              createBtypeItem(
                type.startNo + index,
                voca,
                paperTab,
                wordTextSize,
                lineSpacingValue,
                vocaFirstWordShow,
                columCount,
              ),
            );
            break;
          case 'C':
            items.push(
              createCtypeItem(
                type.startNo + index,
                voca,
                paperTab,
                wordTextSize,
                lineSpacingValue,
                vocaFirstWordShow,
                columCount,
              ),
            );
            break;
          case 'D':
            items.push(
              createDtypeItem(
                type.startNo + index,
                voca,
                paperTab,
                wordTextSize,
                lineSpacingValue,
                vocaFirstWordShow,
                columCount,
              ),
            );
            break;
          case 'E':
            items.push(
              createEtypeItem(
                type.startNo + index,
                voca,
                paperTab,
                wordTextSize,
                lineSpacingValue,
                vocaFirstWordShow,
                columCount,
              ),
            );
            break;
          case 'F':
            items.push(
              createFtypeItem(
                type.startNo + index,
                voca,
                paperTab,
                wordTextSize,
                lineSpacingValue,
                vocaFirstWordShow,
                columCount,
              ),
            );
            break;
          case 'G':
            items.push(
              createGtypeItem(
                type.startNo + index,
                voca,
                paperTab,
                wordTextSize,
                lineSpacingValue,
                vocaFirstWordShow,
                columCount,
              ),
            );
            break;
          case 'H':
            if (voca?.options?.length !== 4) return;
            items.push(
              createHtypeItem(
                type.startNo + index,
                voca,
                paperTab,
                wordTextSize,
                lineSpacingValue,
                columCount,
              ),
            );
            break;
          case 'I':
            if (voca?.options?.length !== 4) return;
            items.push(
              createItypeItem(
                type.startNo + index,
                voca,
                paperTab,
                wordTextSize,
                lineSpacingValue,
                columCount,
              ),
            );
            break;
          case 'J':
            if (voca?.options?.length !== 4) return;
            items.push(
              createJtypeItem(
                type.startNo + index,
                voca,
                paperTab,
                wordTextSize,
                lineSpacingValue,
                examKorShow,
                columCount,
              ),
            );
            break;
          case 'K':
            if (voca?.options?.length !== 4) return;
            items.push(
              createKtypeItem(
                type.startNo + index,
                voca,
                paperTab,
                wordTextSize,
                lineSpacingValue,
                examKorShow,
                columCount,
              ),
            );
            break;
          case 'L':
            if (voca?.options?.length !== 4) return;
            items.push(
              createLtypeItem(
                type.startNo + index,
                voca,
                paperTab,
                wordTextSize,
                lineSpacingValue,
                columCount,
              ),
            );
            break;
          case 'M':
            if (voca?.options?.length !== 4) return;
            items.push(
              createMtypeItem(
                type.startNo + index,
                voca,
                paperTab,
                wordTextSize,
                lineSpacingValue,
                columCount,
              ),
            );
            break;
          default:
            break;
        }
      });
      if (paperTab !== PAPER_TABS.ANSWER) {
        items.push(createLine());
      }
    });
    return items.join('\r\n');
  };

  // '어휘리스트' 시험지 전 유형 공통
  const makedCommonItems = () => {
    let result = `<hp:tbl id="${Date.now()}" zOrder="3" numberingType="TABLE" textWrap="TOP_AND_BOTTOM"
      textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="TABLE"
      repeatHeader="0" rowCnt="${commonPaperVocaList?.length}" colCnt="2" cellSpacing="0" borderFillIDRef="3"
      noAdjust="1">
      <hp:sz width="${columCount === 2 ? MAX_DOUBLE_WIDTH : MAX_SINGLE_WIDTH}" widthRelTo="ABSOLUTE" height="0" heightRelTo="ABSOLUTE"
                      protect="0" />
      <hp:pos treatAsChar="0" affectLSpacing="0" flowWithText="1" allowOverlap="0"
          holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="PARA" vertAlign="TOP"
          horzAlign="LEFT" vertOffset="0" horzOffset="0" />
      <hp:outMargin left="0" right="0" top="0" bottom="0" />
      <hp:inMargin left="509" right="509" top="141" bottom="141" />`;
    commonPaperVocaList?.forEach((voca, index) => {
      result += createCommonVocaListItem(voca, wordTextSize, columCount, index);
    });

    result += `</hp:tbl>`;
    return [result];
  };

  const newSectionXml = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
      <hs:sec xmlns:ha="http://www.hancom.co.kr/hwpml/2011/app"
          xmlns:hp="http://www.hancom.co.kr/hwpml/2011/paragraph"
          xmlns:hp10="http://www.hancom.co.kr/hwpml/2016/paragraph"
          xmlns:hs="http://www.hancom.co.kr/hwpml/2011/section"
          xmlns:hc="http://www.hancom.co.kr/hwpml/2011/core"
          xmlns:hh="http://www.hancom.co.kr/hwpml/2011/head"
          xmlns:hhs="http://www.hancom.co.kr/hwpml/2011/history"
          xmlns:hm="http://www.hancom.co.kr/hwpml/2011/master-page"
          xmlns:hpf="http://www.hancom.co.kr/schema/2011/hpf" xmlns:dc="http://purl.org/dc/elements/1.1/"
          xmlns:opf="http://www.idpf.org/2007/opf/"
          xmlns:ooxmlchart="http://www.hancom.co.kr/hwpml/2016/ooxmlchart"
          xmlns:hwpunitchar="http://www.hancom.co.kr/hwpml/2016/HwpUnitChar"
          xmlns:epub="http://www.idpf.org/2007/ops"
          xmlns:config="urn:oasis:names:tc:opendocument:xmlns:config:1.0">
          <hp:p id="0" paraPrIDRef="24" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
              <hp:run charPrIDRef="26">
                  <hp:secPr id="" textDirection="HORIZONTAL" spaceColumns="1134" tabStop="8000"
                      tabStopVal="4000" tabStopUnit="HWPUNIT" outlineShapeIDRef="0" memoShapeIDRef="0"
                      textVerticalWidthHead="0" masterPageCnt="0">
                      <hp:grid lineGrid="0" charGrid="0" wonggojiFormat="0" />
                      <hp:startNum pageStartsOn="BOTH" page="0" pic="0" tbl="0" equation="0" />
                      <hp:visibility hideFirstHeader="0" hideFirstFooter="0" hideFirstMasterPage="0"
                          border="SHOW_ALL" fill="SHOW_ALL" hideFirstPageNum="0" hideFirstEmptyLine="1"
                          showLineNumber="0" />
                      <hp:lineNumberShape restartType="0" countBy="0" distance="0" startNumber="0" />
                      <hp:pagePr landscape="WIDELY" width="59528" height="84184" gutterType="LEFT_ONLY">
                          <hp:margin header="1417" footer="1417" gutter="0" left="2834" right="2834"
                              top="1417" bottom="1417" />
                      </hp:pagePr>
                      <hp:footNotePr>
                          <hp:autoNumFormat type="DIGIT" userChar="" prefixChar="" suffixChar=""
                              supscript="0" />
                          <hp:noteLine length="-1" type="SOLID" width="0.12 mm" color="#000000" />
                          <hp:noteSpacing betweenNotes="284" belowLine="568" aboveLine="852" />
                          <hp:numbering type="CONTINUOUS" newNum="1" />
                          <hp:placement place="EACH_COLUMN" beneathText="0" />
                      </hp:footNotePr>
                      <hp:endNotePr>
                          <hp:autoNumFormat type="DIGIT" userChar="" prefixChar="" suffixChar=""
                              supscript="0" />
                          <hp:noteLine length="0" type="NONE" width="0.12 mm" color="#000000" />
                          <hp:noteSpacing betweenNotes="0" belowLine="576" aboveLine="864" />
                          <hp:numbering type="CONTINUOUS" newNum="1" />
                          <hp:placement place="END_OF_DOCUMENT" beneathText="0" />
                      </hp:endNotePr>
                      <hp:pageBorderFill type="BOTH" borderFillIDRef="9" textBorder="PAPER"
                          headerInside="0" footerInside="0" fillArea="PAPER">
                          <hp:offset left="1417" right="1417" top="1417" bottom="1417" />
                      </hp:pageBorderFill>
                      <hp:pageBorderFill type="EVEN" borderFillIDRef="1" textBorder="PAPER"
                          headerInside="0" footerInside="0" fillArea="PAPER">
                          <hp:offset left="1417" right="1417" top="1417" bottom="1417" />
                      </hp:pageBorderFill>
                      <hp:pageBorderFill type="ODD" borderFillIDRef="1" textBorder="PAPER"
                          headerInside="0" footerInside="0" fillArea="PAPER">
                          <hp:offset left="1417" right="1417" top="1417" bottom="1417" />
                      </hp:pageBorderFill>
                  </hp:secPr>
                  <hp:ctrl>
                      <hp:colPr id="" type="NEWSPAPER" layout="LEFT" colCount="1" sameSz="1" sameGap="0">
                          <hp:colLine type="DASH" width="0.12 mm" color="#B2B2B2" />
                      </hp:colPr>
                  </hp:ctrl>
              </hp:run>
              <hp:run charPrIDRef="26">
                  <hp:ctrl>
                      <hp:header id="1" applyPageType="ODD">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK" vertAlign="TOP"
                              linkListIDRef="0" linkListNextIDRef="0" textWidth="53860" textHeight="1417"
                              hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="2" styleIDRef="0" pageBreak="0" columnBreak="0"
                                  merged="0">
                                  <hp:run charPrIDRef="4" />
                              </hp:p>
                              <hp:p id="0" paraPrIDRef="2" styleIDRef="0" pageBreak="0" columnBreak="0"
                                  merged="0">
                                  <hp:run charPrIDRef="4" />
                              </hp:p>
                          </hp:subList>
                      </hp:header>
                  </hp:ctrl>
                  <hp:ctrl>
                      <hp:header id="22" applyPageType="BOTH">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK" vertAlign="TOP"
                              linkListIDRef="0" linkListNextIDRef="0" textWidth="53860" textHeight="1417"
                              hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="1" styleIDRef="0" pageBreak="0" columnBreak="0"
                                  merged="0">
                                  <hp:run charPrIDRef="2" />
                              </hp:p>
                          </hp:subList>
                      </hp:header>
                  </hp:ctrl>
                  <hp:ctrl>
                      <hp:header id="40" applyPageType="EVEN">
                          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK" vertAlign="TOP"
                              linkListIDRef="0" linkListNextIDRef="0" textWidth="53860" textHeight="1417"
                              hasTextRef="0" hasNumRef="0">
                              <hp:p id="0" paraPrIDRef="1" styleIDRef="0" pageBreak="0" columnBreak="0"
                                  merged="0">
                                  <hp:run charPrIDRef="2" />
                              </hp:p>
                          </hp:subList>
                      </hp:header>
                  </hp:ctrl>
                  ${createHeaderTable(orgName, className, teacherName, paperName, base64Img, fontSize)}
                  <hp:t />
              </hp:run>
          </hp:p>
          ${
            columCount === 2
              ? `<hp:p id="0" paraPrIDRef="15" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
                  <hp:run charPrIDRef="3">
                      <hp:ctrl>
                          <hp:colPr id="" type="NEWSPAPER" layout="LEFT" colCount="2" sameSz="1"
                              sameGap="1417">
                              <hp:colLine type="DASH" width="0.12 mm" color="#B2B2B2" />
                          </hp:colPr>
                      </hp:ctrl>
                      ${paperTab === PAPER_TABS.VOCABULARY_LIST ? makedCommonItems() : ''}
                  </hp:run>
              </hp:p>`
              : ''
          }
          ${
            paperTab !== PAPER_TABS.VOCABULARY_LIST
              ? makedItems(generatedPaper)
              : ''
          }
      </hs:sec>
      `;

  const hwpxBuffer = await createHwpx(newSectionXml, base64Img);

  return hwpxBuffer;
};
